// extracted by mini-css-extract-plugin
export default {"container":"Client_container__sjtvi","info":"Client_info__Paz-z","subTitle":"Client_subTitle__RIFsA"};